export default __webpack_public_path__ + "static/media/53.027d7359.png";